import React from 'react';
import { SelectItem } from '@/shared/ui/select';
import useAgregateurs from '@/shared/hooks/useAgregateurs';

/**
 * Les options d'agrégateur d'une liste déroulante, LUES EN BASE.
 *
 * Un composant plutôt qu'un `.map` recopié dans chaque écran : c'est la répétition qui
 * a produit le défaut du 31/08. Sept listes écrites à la main, sept endroits à penser à
 * modifier le jour où un agrégateur s'ajoute, et personne ne les a tous pensés.
 *
 * `avecAutre` n'est pas un caprice : « Autre » est une valeur que des clients portent
 * déjà en base. La retirer des listes rendrait leur agrégateur INVISIBLE dans le menu
 * qui est censé l'afficher — le champ paraîtrait vide alors qu'il ne l'est pas.
 */
export const VALEUR_AUTRE = 'Autre';

export default function OptionsAgregateurs({ avecAutre = true }) {
  const { agregateurs } = useAgregateurs();
  return (
    <>
      {agregateurs.map((a) => (
        <SelectItem key={a.key || a.name} value={a.name}>{a.name}</SelectItem>
      ))}
      {avecAutre ? <SelectItem value={VALEUR_AUTRE}>{VALEUR_AUTRE}</SelectItem> : null}
    </>
  );
}
